import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

export const createNotification = (params) => {
  return Api(endPoints.createNotification, params, requestType.POST);
};

export const updateNotification = (id, params) => {
  return Api(`${endPoints.updateNotification}/${id}`, params, requestType.PUT);
};

export const getAllNotifications = () => {
  return Api(endPoints.fetchAllNotifications, null, requestType.GET);
};
export const getNotificationsByType = () => {
  return Api(endPoints.getNotificationsByType, null, requestType.GET);
};

export const getNotificationById = (id) => {
  return Api(`${endPoints.getNotificationById}/${id}`, null, requestType.GET);
};

export const resendNotification = (id) => {
  return Api(`${endPoints.resendNotification}/${id}`, null, requestType.POST);
};  

export const deleteNotification = (id) => {
  return Api(`${endPoints.updateNotification}/${id}`, null, requestType.DELETE);
};

export const marksAllRead = () => {
  return Api(endPoints.marksAllRead, null, requestType.PUT);
};
